import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { Provider } from 'react-redux';
import { MapProvider } from 'react-map-gl';
import { WebStorageStateStore } from 'oidc-client-ts';
import { UserProvider } from 'core/store/UserContext';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { store } from './core/store/Store';

const oidcConfig: AuthProviderProps = {
  authority: process.env.REACT_APP_IDP_URL ?? '',
  client_id: process.env.REACT_APP_IDP_CLIENTID ?? '',
  redirect_uri: `${process.env.REACT_APP_URL}/login-successful`,
  post_logout_redirect_uri: `${process.env.REACT_APP_URL}/login`,
  response_type: 'code',
  scope:
    'openid profile SD.IDM.CORE SD.ItineraryViewer.API SD.IDM.CORE.Services.HistoricalData',
  revokeTokensOnSignout: true,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider {...oidcConfig}>
          <UserProvider>
            <MapProvider>
              <App />
            </MapProvider>
          </UserProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
